import { Component, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AdminUserService } from 'src/app/services/SystemSettings/AdminUser.service';

export interface IFavoriteMenuItem {
  MenuId: number;        
  MenuName: string;      
  FormName?: string;     
  SortOrder?: number;
}


export const FAVORITE_MENU_ICONS: Record<string, string> = {
  '/ops/vendors':        'nav-vendor',
  '/ops/qdr':            'nav-QDR',
  '/ops/booth-transfer': 'nav-BoothTransfer',
  '/ops/delete-rental':  'nav-DeleteRental',
  '/ops/void':           'nav-void',
  '/ops/history':        'nav-history',
  '/ops/view-layout':    'nav-layout',
  '/ops/deposit':        'nav-deposit',
  '/ops/report':         'nav-reports',
  '/sec/usr':            'fas fa-users',
};

const DEFAULT_FAVORITE_ICON = 'fas fa-star';

@Component({
  selector: 'app-favorite-menu',
  templateUrl: './favorite-menu.component.html',
  styleUrls: ['./favorite-menu.component.scss']
})
export class FavoriteMenuComponent implements OnDestroy {
  isOpen = false;
  isLoading = false;
  loadFailed = false;
  favorites: IFavoriteMenuItem[] = [];

  private loadSub?: Subscription;

  constructor(
    private adminUserService: AdminUserService,
    private router: Router,
    private elementRef: ElementRef<HTMLElement>
  ) { }

  toggle(event?: Event) {
    event?.stopPropagation();
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.isLoading = true;
    this.loadFailed = false;

    this.loadSub?.unsubscribe();
    this.loadSub = this.adminUserService.GetUserFavoriteMenu().subscribe({
      next: (res: any) => {
        this.favorites = (res?.SelectedOptions ?? [])
          .filter((f: IFavoriteMenuItem) => this.isAppRoute(f.FormName));
        this.isLoading = false;
      },
      error: () => {
        this.favorites = [];
        this.isLoading = false;
        this.loadFailed = true;
      }
    });
  }

  close() {
    this.isOpen = false;
  }

  go(item: IFavoriteMenuItem) {
    this.close();
    if (this.isAppRoute(item.FormName)) {
      this.router.navigateByUrl(item.FormName!.trim());
    }
  }

  iconFor(item: IFavoriteMenuItem): string {
    const path = (item?.FormName ?? '').trim().split('?')[0].toLowerCase();
    return FAVORITE_MENU_ICONS[path] ?? DEFAULT_FAVORITE_ICON;
  }

  trackByMenuId(_: number, item: IFavoriteMenuItem) {
    return item.MenuId;
  }

  private isAppRoute(path?: string): boolean {
    const value = (path ?? '').trim();
    return value.startsWith('/') && !value.startsWith('//');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!event.isTrusted) return;
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.close();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.close();
  }

  ngOnDestroy(): void {
    this.loadSub?.unsubscribe();
  }
}
